<template>
  <div v-if="dadosProposta.dadosCliente" class="wrapperPage pt-8">
    <div class="container flex flex-row items-center justify-between">
      <div class="logo ml-4 w-full">
        <img
          class="img-logo"
          src="../../assets/images/logo/logo-bpseguradora.svg"
        />
      </div>
      <div class="w-full flex flex-col p-1 text-sm">
        <h3 class="flex justify-center">{{ titulo }}</h3>
        <h6 class="flex justify-center" v-if="isApolice()">
          {{ formataNumeroApolice(dadosProposta.policyNumber) }}
        </h6>
      </div>
      <div class="w-full flex flex-col p-1 text-sm items-end">
        <img
          v-if="dadosProposta.regionalLogo"
          class="img-logo"
          :src="dadosProposta.regionalLogo"
        />
        <h3 v-if="!dadosProposta.regionalLogo" class="text-right">
          {{ dadosProposta.regional }}
        </h3>
      </div>
    </div>

    <div class="container">
      <!-- DADOS PROPOSTA -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">
              DADOS DA {{ isApolice() ? 'APÓLICE' : 'PROPOSTA' }}
            </th>
          </tr>
          <tr v-if="!isApolice()">
            <td class="pl-3" colspan="2">
              <b>N° Proposta:</b>
              {{ formataNumeroProposta(dadosProposta.proposalNumber) }}
            </td>
            <td class="pl-3">
              <b>Data da Proposta:</b>
              {{ functions.formatDateAndHour(dadosProposta.proposalDate) }}
            </td>
          </tr>
          <tr v-if="isApolice()">
            <td class="pl-3">
              <b>N° Apólice:</b>
              {{ formataNumeroApolice(dadosProposta.policyNumber) }}
            </td>
            <td class="pl-3">
              <b>N° Proposta:</b>
              {{ formataNumeroProposta(dadosProposta.proposalNumber) }}
            </td>
            <td class="pl-3">
              <b>N° Endosso:</b>
              {{ dadosProposta.idEndosso }}
            </td>
            <td class="pl-3">
              <b>Data da Apólice:</b>
              {{ functions.formatDateAndHour(dadosProposta.dataAdesao) }}
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="4">
              <b>Vigência da Apólice: </b>24:00 de
              {{
                functions.formataDataHoraPadraoBR(
                  dadosProposta.inicioVigencia,
                  false,
                )
              }}
              até 24:00 de
              {{
                functions.formataDataHoraPadraoBR(
                  dadosProposta.fimVigencia,
                  false,
                )
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="2"><b>Seguradora: </b>BP SEGURADORA</td>
            <td class="pl-3"><b>CNPJ: </b>50.180.527/0001-13</td>
            <td class="pl-3"><b>SUSEP: </b>{{ SUSEP_CODE.BP_SEGURADORA }}</td>
          </tr>
          <tr>
            <td colspan="2" class="pl-3"><b>Ramo: </b>05.31 - Automóvel</td>
            <td class="pl-3" colspan="1">
              <div
                v-if="
                  isApolice ||
                  hasInsuranceCompany(
                    dadosProposta.bonus.insurance_company_code,
                    insuranceCompanies,
                  )
                "
              >
                <b>Classe de bônus:</b>
                {{ dadosProposta.bonus.bonus }}
              </div>
            </td>
            <td class="pl-3" colspan="1">
              <div v-if="dadosProposta.cnsegCi">
                <b>CI:</b>
                {{ dadosProposta.cnsegCi }}
              </div>
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.DATA"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.DATA"
        ></div>
      </vx-card>

      <!-- DADOS DA CORRETORA -->
      <vx-card class="mt-2 card-impressao pagebreak-inside-avoid">
        <table class="table card-impressao table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">DADOS DA CORRETORA</th>
          </tr>
          <tr>
            <td class="pl-3" colspan="2">
              <b>Corretora:</b>
              {{
                dadosCotacao.broker.corporateReason || dadosProposta.regional
              }}
            </td>
            <td class="pl-3" colspan="2">
              <b>CPF/CNPJ:</b> {{ dadosProposta.regionalCnpj }}
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="2">
              <b>SUSEP:</b> {{ dadosProposta.regionalSusep }}
            </td>
            <td class="pl-3" colspan="1">
              <b>Cidade: </b>{{ dadosProposta.regionalCidade }}
            </td>
            <td class="pl-3" colspan="1">
              <b>UF:</b> {{ dadosProposta.regionalEstado }}
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="2">
              <b>Telefone:</b> {{ dadosCotacao.broker.phoneNumber }}
            </td>
            <td class="pl-3" colspan="1">
              <b>Email:</b> {{ dadosCotacao.broker.email }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.BROKER_DATA"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.BROKER_DATA"
        ></div>
      </vx-card>

      <!-- DADOS PESSOAIS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="3">SEGURADO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{
                getLabelSegurado(
                  dadosProposta.dadosCliente.cpf,
                  dadosProposta.dadosCliente.associadoNomeSocial,
                )
              }}</b
              >:
              {{
                dadosProposta.dadosCliente.associado
                  ? dadosProposta.dadosCliente.associado
                  : ''
              }}
            </td>
            <td
              class="pl-3"
              v-if="
                isPessoaFisica(dadosProposta.dadosCliente.cpf) &&
                !dadosProposta.dadosCliente.associadoNomeSocial
              "
            >
              <b>Nome Social:</b>
            </td>
            <td class="pl-3">
              <b>{{
                isPessoaFisica(dadosProposta.dadosCliente.cpf) ? 'CPF' : 'CNPJ'
              }}</b
              >:
              {{
                dadosProposta.dadosCliente.cpf
                  ? dadosProposta.dadosCliente.cpf
                  : ''
              }}
            </td>
          </tr>
          <tr v-if="isPessoaFisica(dadosProposta.dadosCliente.cpf)">
            <td class="pl-3">
              <b>Data de Nascimento</b>:
              {{
                dadosProposta.dadosCliente.dataNascimento != 'Invalid date'
                  ? dadosProposta.dadosCliente.dataNascimento
                  : ''
              }}
            </td>
            <td class="pl-3" colspan="2">
              <b>Sexo de Nascimento</b>:
              {{
                dadosProposta.dadosCliente.sexo
                  ? dadosProposta.dadosCliente.sexo
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>E-mail</b>:
              {{
                dadosProposta.dadosCliente.email
                  ? dadosProposta.dadosCliente.email
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Celular</b>:
              {{
                dadosProposta.dadosCliente.celular
                  ? dadosProposta.dadosCliente.celular
                  : ''
              }}
            </td>
          </tr>
          <tr v-if="isPessoaFisica(dadosProposta.dadosCliente.cpf)">
            <td class="pl-3">
              <b>Estado Civil</b>:
              {{
                dadosProposta.dadosCliente.estadoCivil
                  ? dadosProposta.dadosCliente.estadoCivil
                  : ''
              }}
            </td>
            <td class="pl-3" colspan="2">
              <b>É uma pessoa politicamente exposta (PPE)?</b>:
              {{
                dadosProposta.dadosCliente.politicamenteExposto ? 'Sim' : 'Não'
              }}
            </td>
          </tr>
          <tr v-if="dadosProposta.dadosCliente.politicamenteExposto">
            <td class="pl-3">
              <b>Tipo de PPE</b>:
              {{
                dadosProposta.dadosCliente.ppeDescription
                  ? dadosProposta.dadosCliente.ppeDescription
                  : ''
              }}
            </td>
          </tr>
          <tr
            v-if="
              !isPessoaFisica(dadosProposta.dadosCliente.cpf) &&
              dadosProposta.dadosCliente.rg_ie
            "
          >
            <td class="pl-3">
              <b>Inscrição Estadual</b>:
              {{ dadosProposta.dadosCliente.rg_ie }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.INSURED"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.INSURED"
        ></div>
      </vx-card>

      <!-- ENDEREÇO -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table">
          <tr class="title p-1 w-full">
            <th colspan="4">ENDEREÇO DO SEGURADO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>CEP</b>:
              {{
                dadosProposta.dadosCliente.cep
                  ? dadosProposta.dadosCliente.cep
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Endereço</b>:
              {{
                dadosProposta.dadosCliente.endereco
                  ? dadosProposta.dadosCliente.endereco
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Número</b>:
              {{
                dadosProposta.dadosCliente.numero
                  ? dadosProposta.dadosCliente.numero
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Complemento</b>:
              {{
                dadosProposta.dadosCliente.complemento
                  ? dadosProposta.dadosCliente.complemento
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Bairro</b>:
              {{
                dadosProposta.dadosCliente.bairro
                  ? dadosProposta.dadosCliente.bairro
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Cidade</b>:
              {{
                dadosProposta.dadosCliente.cidade
                  ? dadosProposta.dadosCliente.cidade
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Estado</b>:
              {{
                dadosProposta.dadosCliente.estado
                  ? dadosProposta.dadosCliente.estado
                  : ''
              }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.INSURED_ADDRESS"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.INSURED_ADDRESS"
        ></div>
      </vx-card>

      <!-- BÔNUS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table">
          <tr class="title p-1 w-full">
            <th colspan="4">RENOVAÇÃO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>É uma renovação?</b>:
              {{
                getInsuranceCompanyLabel(
                  dadosProposta.bonus.insurance_company_code,
                  insuranceCompanies,
                )
              }}
            </td>
            <td v-if="dadosProposta.bonus.ci" class="pl-3">
              <b>CI anterior</b>:
              {{ dadosProposta.bonus.ci }}
            </td>
            <td v-if="dadosProposta.bonus.policy_number" class="pl-3">
              <b>N° da apólice anterior</b>:
              {{ dadosProposta.bonus.policy_number }}
            </td>
          </tr>
          <tr>
            <td
              v-if="dadosProposta.bonus.previous_coverage_end_date"
              class="pl-3"
            >
              <b>Fim da vigência anterior</b>:
              {{
                functions.formataDataHoraPadraoBR(
                  dadosProposta.bonus.previous_coverage_end_date,
                  false,
                )
              }}
            </td>
            <td v-if="dadosProposta.bonus.is_renovation" class="pl-3">
              <b>Veículo igual ao anterior?</b>:
              {{ getVehicleIsSameLabel(dadosProposta.bonus.is_same_vehicle) }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.RENEWAL"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.RENEWAL"
        ></div>
      </vx-card>

      <!-- CONDUTOR -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table">
          <tr class="title p-1 w-full">
            <th colspan="3">CONDUTOR PRINCIPAL</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Condutor é o segurado?</b>:
              {{
                dadosProposta.dadosCliente.cpf === dadosProposta.driver.taxId
                  ? 'Sim'
                  : 'Não'
              }}
            </td>
            <td class="pl-3">
              <b>{{
                getLabelSegurado(
                  dadosProposta.driver.taxId,
                  dadosProposta.driver.socialName,
                )
              }}</b
              >:
              {{ dadosProposta.driver.name }}
            </td>
            <td v-if="!dadosCotacao.driver.social_name" class="pl-3">
              <b>Nome Social:</b>
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>CPF</b>:
              {{ dadosProposta.driver.taxId }}
            </td>
            <td class="pl-3" colspan="2">
              <b>Data de Nascimento</b>:
              {{
                functions.formataDataHoraPadraoBR(
                  dadosProposta.driver.birthdate,
                  false,
                )
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Sexo de Nascimento</b>:
              {{ dadosProposta.driver.gender }}
            </td>
            <td class="pl-3" v-if="dadosProposta.driver.email">
              <b>Email</b>:
              {{ dadosProposta.driver.email }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.MAIN_DRIVER"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.MAIN_DRIVER"
        ></div>
      </vx-card>

      <!-- PERNOITE -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table">
          <tr class="title p-1 w-full">
            <th colspan="4">ENDEREÇO DE PERNOITE</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>CEP</b>:
              {{ dadosCotacao.overnight_address.zip_code }}
            </td>
            <td class="pl-3">
              <b>Endereço</b>:
              {{ dadosCotacao.overnight_address.street }}
            </td>
            <td class="pl-3">
              <b>Número</b>:
              {{ dadosCotacao.overnight_address.number }}
            </td>
            <td class="pl-3">
              <b>Complemento</b>:
              {{ dadosCotacao.overnight_address.complement }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Bairro</b>:
              {{ dadosCotacao.overnight_address.neighborhood }}
            </td>
            <td class="pl-3">
              <b>Cidade</b>:
              {{ dadosCotacao.overnight_address.city }}
            </td>
            <td class="pl-3" colspan="2">
              <b>Estado</b>:
              {{ dadosCotacao.overnight_address.state }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.OVERNIGHT_ADDRESS"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.OVERNIGHT_ADDRESS"
        ></div>
      </vx-card>

      <!-- DADOS VEÍCULO -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table">
          <tr class="title p-1 w-full">
            <th colspan="4">DADOS DO VEÍCULO</th>
          </tr>
          <tr v-if="this.dadosProposta.idTipoApolice != TIPO_APOLICE.RCVAT">
            <td class="pl-3">
              <b>Veículo 0 km?</b>:
              {{ dadosProposta.isZero ? 'Sim' : 'Não' }}
            </td>
            <td class="pl-3">
              <b>Chassi</b>:
              {{ dadosProposta.dadosVeiculo.chassi }}
            </td>
            <td class="pl-3">
              <b>Placa</b>:
              {{ dadosProposta.dadosVeiculo.placa }}
            </td>
          </tr>
          <tr v-if="this.dadosProposta.idTipoApolice != TIPO_APOLICE.RCVAT">
            <td class="pl-3">
              <b>Marca</b>:
              {{ dadosProposta.dadosVeiculo.veiculoMarca }}
            </td>
            <td class="pl-3">
              <b>Modelo</b>:
              {{ dadosProposta.dadosVeiculo.veiculoModelo }}
            </td>
            <td class="pl-3">
              <b>Ano Modelo</b>:
              {{
                dadosProposta.dadosVeiculo.anoModelo === ZERO_KM_VEHICLE_YEAR_ID
                  ? '0Km'
                  : dadosProposta.dadosVeiculo.anoModelo
              }}
            </td>
            <td class="pl-3">
              <b>Código da Fipe</b>: {{ dadosProposta.dadosVeiculo.codigoFipe }}
            </td>
          </tr>
          <tr>
            <td v-if="dadosProposta.isZero && dadosProposta.nf" class="pl-3">
              <b>Nº da nota fiscal</b>:
              {{ dadosProposta.nf }}
            </td>
            <td
              v-if="dadosProposta.isZero && dadosProposta.dataNf"
              class="pl-3"
            >
              <b>Data de emissão da nota fiscal</b>:
              {{ dadosProposta.dataNf }}
            </td>
            <td v-if="dadosProposta.isZero" class="pl-3">
              <b>Veículo saiu da concessionária?</b>
              {{ dadosProposta.veiculoSaiuConcessionaria ? 'Sim' : 'Não' }}
            </td>
            <td
              v-if="
                dadosProposta.isZero &&
                dadosProposta.dataVeiculoSaiuConcessionaria
              "
              class="pl-3"
            >
              <b>Data de saída da concessionária</b>:
              {{
                functions.formataDataHoraPadraoBR(
                  dadosProposta.dataVeiculoSaiuConcessionaria,
                  false,
                )
              }}
            </td>
            <td></td>
          </tr>
          <tr v-for="(vehicle, index) in getVehicles()" :key="index">
            <td class="pl-3"><b>Tipo</b>: {{ vehicle.typeName }}</td>
            <td class="pl-3"><b>Grupo</b>: {{ vehicle.groupName }}</td>
            <td class="pl-3"><b>Quantidade</b>: {{ vehicle.quantity }}</td>
          </tr>
        </table>

        <div>
          <table
            v-for="(implemento, index) in dadosProposta.implementos"
            :key="`id-${index}`"
            class="table mt-6"
          >
            <tr v-if="index == 0" class="title p-1 w-full">
              <th colspan="4">
                {{
                  dadosProposta.implementos.length > 1
                    ? 'DADOS DOS IMPLEMENTOS'
                    : 'DADOS DO IMPLEMENTO'
                }}
              </th>
            </tr>
            <tr>
              <td class="pl-3"><b>Tipo</b>: {{ implemento.tipo }}</td>
              <td class="pl-3"><b>Marca</b>: {{ implemento.marca }}</td>
              <td class="pl-3"><b>Modelo</b>: {{ implemento.modelo }}</td>
            </tr>
            <tr v-if="implemento.anoFabricacao || implemento.anoModelo">
              <td v-if="implemento.anoFabricacao" class="pl-3">
                <b>Ano Fabricação</b>:
                {{
                  implemento.anoFabricacao === ZERO_KM_VEHICLE_YEAR_ID
                    ? '0Km'
                    : implemento.anoFabricacao
                }}
              </td>
              <td v-if="implemento.anoModelo" class="pl-3">
                <b>Ano Modelo</b>:
                {{
                  implemento.anoModelo === ZERO_KM_VEHICLE_YEAR_ID
                    ? '0Km'
                    : implemento.anoModelo
                }}
              </td>
            </tr>
            <tr>
              <td class="pl-3"><b>Chassi</b>: {{ implemento.chassi }}</td>
              <td class="pl-3"><b>Placa</b>: {{ implemento.placa }}</td>
              <td class="pl-3">&nbsp;</td>
            </tr>
            <tr>
              <td calss="pl-3" colspan="3">
                <b>Valor Protegido</b>:
                {{ implemento.valorCobertura | currency }}
              </td>
            </tr>
          </table>
        </div>

        <!-- valor total de cobertura -->
        <div v-if="dadosProposta.implemento">
          <table class="table mt-6">
            <tr class="title p-1 w-full">
              <th colspan="4">VALOR COBERTURA DO CONJUNTO</th>
            </tr>
            <tr>
              <td class="pl-3" colspan="4">
                <b>Valor cobertura do conjunto (Caminhão + implemento)</b>:
                {{ dadosProposta.valorTotalConjunto | currency }}
              </td>
            </tr>
          </table>
        </div>

        <!-- agregados -->
        <div v-if="dadosProposta.agregado">
          <table
            v-for="(agregado, index) in dadosProposta.agregados"
            :key="`id-${index}`"
            class="table mt-6"
          >
            <tr v-if="index == 0" class="title p-1 w-full">
              <th colspan="4">
                {{
                  dadosProposta.agregados.length > 1
                    ? 'DADOS DOS AGREGADOS'
                    : 'DADOS DO AGREGADO'
                }}
              </th>
            </tr>
            <tr>
              <td class="pl-3"><b>Tipo</b>: {{ agregado.tipo }}</td>
              <td class="pl-3"><b>Marca</b>: {{ agregado.marca }}</td>
              <td class="pl-3"><b>Modelo</b>: {{ agregado.modelo }}</td>
            </tr>
            <tr v-if="agregado.anoFabricacao || agregado.anoModelo">
              <td v-if="agregado.anoFabricacao" class="pl-3">
                <b>Ano Fabricação</b>:
                {{
                  agregado.anoFabricacao === ZERO_KM_VEHICLE_YEAR_ID
                    ? '0Km'
                    : agregado.anoFabricacao
                }}
              </td>
              <td v-if="agregado.anoModelo" class="pl-3">
                <b>Ano Modelo</b>:
                {{
                  agregado.anoModelo === ZERO_KM_VEHICLE_YEAR_ID
                    ? '0Km'
                    : agregado.anoModelo
                }}
              </td>
            </tr>
            <tr>
              <td class="pl-3"><b>Chassi</b>: {{ agregado.chassi }}</td>
              <td class="pl-3"><b>Placa</b>: {{ agregado.placa }}</td>
              <td class="pl-3">&nbsp;</td>
            </tr>
            <tr>
              <td class="pl-3">
                <b>Valor Protegido</b>:
                {{ agregado.valorCobertura | currency }}
              </td>
              <td class="pl-3">
                <b>Entrada</b>:
                {{
                  somaValorTotalValoresAvista(agregado.produtosAgregado)
                    | currency
                }}
              </td>
              <td class="pl-3">
                <b>Cota de participação</b>:
                {{ agregado.valorMinimoParticipacao | currency }}
              </td>
            </tr>
          </table>
        </div>
        <div
          v-if="customSectionsMsgs.VEHICLE"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.VEHICLE"
        ></div>
      </vx-card>

      <!-- AGRAVOS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="2">QUESTIONÁRIO DE AVALIAÇÃO DE RISCO</th>
          </tr>
          <tr v-for="(item, index) in dadosProposta.agravos" :key="index">
            <td class="pl-3">{{ getAgravoPergunta(item) }}</td>
            <td class="pl-3">{{ getAgravoResposta(item) }}</td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.RISK_QUESTIONNAIRE"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.RISK_QUESTIONNAIRE"
        ></div>
      </vx-card>

      <!-- COBERTURAS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="3">COBERTURAS</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Cobertura</b>
            </td>
            <td class="pl-3">
              <b>Limite Máximo Indenização</b>
            </td>
            <td class="pl-3">
              <b>Prêmio Líquido</b>
            </td>
          </tr>
          <tr v-for="(item, index) in selectedCoverage" :key="index">
            <td class="pl-3">
              {{ item.productName }}
            </td>
            <td class="pl-3">
              {{ getFormattedItemLmi(item) }}
            </td>
            <td class="pl-3">
              {{ functions.formataReal(item.values.originalValue) }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.COVERAGES"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.COVERAGES"
        ></div>
      </vx-card>

      <!-- SERVIÇOS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="1">SERVIÇOS</th>
          </tr>
          <tr v-for="(item, index) in selectedServices" :key="index">
            <td class="pl-3">
              <b>Serviço</b>:
              {{ getFormattedItemName(item) }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.SERVICES"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.SERVICES"
        ></div>
      </vx-card>

      <!-- FRANQUIA DE VIDROS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">FRANQUIA</th>
          </tr>
          <tr>
            <td class="pl-3">{{ comprehensiveLabel }}</td>
            <td class="pl-3">
              <b>Franquia</b>:
              {{
                functions.formataReal(
                  getComprehensiveFranchise(selectedCoverage),
                )
              }}
            </td>
            <td v-if="selectedGlass.length > 0" class="pl-3">
              {{ formatNameGlass(selectedGlass[0].name) }}
            </td>
            <td v-if="selectedGlass.length > 0" class="pl-3">
              <b>Franquia</b>:
              {{ functions.formataReal(selectedGlass[0].value) }}
            </td>
          </tr>
          <tr v-for="(item, index) in selectedGlassOdd" :key="index">
            <td class="pl-3">
              {{ formatNameGlass(item.name) }}
            </td>
            <td class="pl-3">
              <b>Franquia</b>:
              {{ functions.formataReal(item.value) }}
            </td>
            <td v-if="selectedGlassEven[index + 1]" class="pl-3">
              {{ formatNameGlass(selectedGlassEven[index + 1].name) }}
            </td>
            <td v-if="selectedGlassEven[index + 1]" class="pl-3">
              <b>Franquia</b>:
              {{ functions.formataReal(selectedGlassEven[index + 1].value) }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.FRANCHISE"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.FRANCHISE"
        ></div>
      </vx-card>

      <!-- PAGAMENTO -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">PAGAMENTO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Prêmio Líquido</b>:
              {{ functions.formataReal(dadosCotacao.prize.tariff_prize) }}
            </td>
            <td class="pl-3">
              <b>Juros</b>:
              {{ functions.formataReal(dadosCotacao.prize.interest) }}
            </td>
            <td class="pl-3">
              <b>IOF</b>:
              {{ functions.formataReal(dadosCotacao.prize.iof_value) }}
            </td>
            <td class="pl-3">
              <b>Prêmio Final</b>:
              {{ functions.formataReal(dadosCotacao.prize.prize) }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Forma de Pagamento</b>:
              {{ dadosProposta.nomePagamento }}
            </td>
            <td class="pl-3" v-if="showInstallments()">
              <b>Nº de Parcelas</b>: {{ dadosCotacao.prize.installments }} x
              {{ functions.formataReal(dadosCotacao.prize.monthlyPrize) }}
            </td>
            <td class="pl-3" colspan="2">
              <b>Dia de Vencimento</b>:
              {{
                dadosProposta.nomePagamento === 'Cartão de Crédito'
                  ? creditCardDueDate
                  : dadosProposta.diaVencimentoMensalidade
              }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.PAYMENT"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.PAYMENT"
        ></div>
      </vx-card>

      <vx-card
        v-if="isApolice() && (isBillet || isCreditCard)"
        class="mt-2 pagebreak-inside-avoid"
      >
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">PARCELAMENTO</th>
          </tr>
          <tr
            v-for="installment in getPaymentInstallments()"
            :key="installment.number"
          >
            <td class="pl-3">
              <b>Parcela</b>:
              {{ installment.number }}
            </td>
            <td class="pl-3">
              <b>Data de vencimento</b>:
              {{
                isBillet
                  ? functions.formataDataHoraPadraoBR(
                      installment.dueDate,
                      false,
                    )
                  : ''
              }}
              {{ isCreditCard ? creditCardDueDate : '' }}
            </td>
            <td class="pl-3">
              <b>Valor</b>:
              {{ functions.formataReal(installment.value) }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.INSTALLMENTS"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.INSTALLMENTS"
        ></div>
      </vx-card>

      <!-- DISPOSIÇÕES -->
      <vx-card class="mt-2">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="1">DISPOSIÇÕES GERAIS</th>
          </tr>
          <tr>
            <td class="pl-2 pr-2" style="text-align: justify">
              <div
                style="text-align: justify"
                class="pl-3 pt-3"
                v-html="customSectionsMsgs.GENERAL_PROVISIONS"
              ></div>
            </td>
          </tr>
        </table>
      </vx-card>

      <!-- CONTRATO -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <div style="text-align: justify" v-html="textoContrato"></div>
        <div>
          {{
            dadosProposta.dadosAssociacao.cidade
              ? dadosProposta.dadosAssociacao.cidade
              : 'Belo Horizonte'
          }},
          {{
            functions.formataDataMomentJS(
              isApolice()
                ? dadosProposta.dataAdesao
                : dadosProposta.proposalDate,
            )
          }}
        </div>

        <div
          :class="
            isApolice() ? 'flex justify-center' : 'grid grid-cols-3 gap-4'
          "
          class="p-5 mt-5"
        >
          <div
            :class="isApolice() ? 'w-1/4' : ''"
            class="flex justify-center items-center"
          >
            <img
              class="imagem"
              src="../../assets/images/assinatura/assinatura.jpeg"
              width="100"
              height="100"
              alt="Assinatura da Seguradora"
            />
          </div>

          <div class="flex justify-center items-center" v-if="!isApolice()">
            <div
              class="imagem"
              style="margin-left: 15px; width: 100px; height: 100px"
            />
          </div>

          <div class="flex justify-center items-center" v-if="!isApolice()">
            <div
              class="imagem"
              style="margin-left: 15px; width: 100px; height: 100px"
            />
          </div>
        </div>

        <div
          :class="
            isApolice() ? 'flex justify-center' : 'grid grid-cols-3 gap-4'
          "
        >
          <div
            :class="isApolice() ? 'w-1/4' : ''"
            class="flex flex-col justify-start items-center assinatura"
          >
            <p><b>BP SEGURADORA SA</b></p>
            <p><b>50.180.527/0001-13</b></p>
          </div>

          <div
            class="flex flex-col justify-start items-center text-center assinatura"
            v-if="!isApolice()"
          >
            <p>
              <b>{{
                dadosCotacao.broker.corporateReason || dadosProposta.regional
              }}</b>
            </p>
            <p>
              <b>{{ dadosProposta.regionalCnpj || '-' }}</b>
            </p>
          </div>

          <div
            class="flex flex-col justify-start items-center assinatura"
            v-if="!isApolice()"
          >
            <p>
              <b>{{ dadosProposta.dadosCliente.associado }}</b>
            </p>
            <p>
              <b>{{ dadosProposta.dadosCliente.cpf || '-' }}</b>
            </p>
          </div>
        </div>

        <div class="mt-5 flex justify-end">
          <vs-button
            color="success"
            type="gradient"
            class="w-2/6 btn-print"
            @click="imprimePDF()"
          >
            Exportar PDF
          </vs-button>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
const { TIPO_APOLICE } = require('../../../common/constant/tipo_apolice.js');
import VxCard from '../../components/vx-card/VxCard.vue';
import { SUSEP_CODE } from '../../constants/susep.code.enum.js';
import locale from '../../locale.js';
import {
  getAllFranchises,
  getComprehensiveFranchise,
  getCustomSectionMsgs,
  getFormattedItemLmi,
  getFormattedItemName,
  getInsuranceCompanyLabel,
  getSelectedGlassServices,
  hasInsuranceCompany,
  somaValorTotalValoresAvista,
} from '../../services/contract.js';
import contractApi from '../../services/contract.api.js';
import { calcularFranquia } from '../../services/cotacao.js';
import {
  PAYMENT_METHODS,
  PDF_DOCUMENT_TYPES,
  PRODUCTS_GROUPING,
  PURCHASE_STATUS,
  TRANSLATE_GLASS_FRANCHISES,
  VEHICLE_TYPE_CODE_LABEL,
  ZERO_KM_VEHICLE_YEAR_ID,
} from '../../utils/constants.js';
import functions from '../../utils/functions.js';
import notify from '../../utils/notify.js';

export default {
  data() {
    return {
      SUSEP_CODE,
      comprehensiveLabel: 'Casco compreensivo',
      PRODUCTS_GROUPING,
      hasInsuranceCompany,
      getInsuranceCompanyLabel,
      somaValorTotalValoresAvista,
      getFormattedItemLmi,
      getFormattedItemName,
      getComprehensiveFranchise,
      customSectionsMsgs: {},
      TIPO_APOLICE,
      dadosProposta: {},
      dadosCotacao: {},
      quotationData: {},
      textoContrato: '',
      functions,
      controller: 'auto',
      action: 'quotations',
      creditCardDueDate: 'De acordo com a fatura',
      insuranceCompanies: [],
    };
  },
  computed: {
    isCreditCard() {
      return (
        this.dadosCotacao.payment.payment_method_id ===
        PAYMENT_METHODS.CREDIT_CARD.id
      );
    },
    isBillet() {
      return (
        this.dadosCotacao.payment.payment_method_id ===
        PAYMENT_METHODS.BILLET.id
      );
    },
    titulo() {
      if (this.isApolice()) {
        return 'Apólice de Seguro';
      }
      return 'Proposta de Seguro';
    },
    selectedCoverage() {
      return functions.getContractedProductsWithDetails(
        this.dadosCotacao.coverage_contracted,
        this.dadosCotacao.all_coverages,
        false,
      );
    },
    selectedServices() {
      return functions.getContractedProductsWithDetails(
        this.dadosCotacao.coverage_contracted,
        this.dadosCotacao.all_coverages,
        true,
      );
    },
    selectedGlass() {
      const glassServices = this.selectGlassServices();
      return getAllFranchises(glassServices);
    },
    selectedGlassOdd() {
      return this.selectedGlass.filter((_, index) => index % 2 !== 0);
    },
    selectedGlassEven() {
      return this.selectedGlass.filter((_, index) => index % 2 === 0);
    },
    ZERO_KM_VEHICLE_YEAR_ID() {
      return ZERO_KM_VEHICLE_YEAR_ID;
    },
  },
  methods: {
    getPaymentInstallments() {
      if (this.isBillet && this.dadosCotacao.payment.billets) {
        return this.dadosCotacao.payment.billets.map((billet) => {
          return {
            number: billet.installment,
            value: billet.boletoValue,
            dueDate: billet.dueDate,
          };
        });
      }
      if (this.isCreditCard && this.dadosCotacao.prize) {
        const installments = this.dadosCotacao.prize.installments;
        return Array.from({ length: installments }, (_, index) => ({
          number: `${index + 1}/${installments}`,
          value: this.dadosCotacao.prize.monthlyPrize,
        }));
      }
      return [];
    },
    selectGlassServices() {
      return getSelectedGlassServices(
        this.dadosCotacao.coverage_contracted,
        this.dadosCotacao.all_coverages.details,
      );
    },
    formatNameGlass(name) {
      return TRANSLATE_GLASS_FRANCHISES[name] || name;
    },
    formataNumeroProposta(proposalNumber) {
      return functions.formatEmitterNumber(
        proposalNumber,
        this.dadosProposta.idTipoApolice,
        'PROPOSAL',
      );
    },
    formataNumeroApolice(policyNumber) {
      return functions.formatEmitterNumber(
        policyNumber,
        this.dadosProposta.idTipoApolice,
        'POLICY',
      );
    },
    imprimePDF() {
      window.print();
    },
    getAgravoPergunta(item) {
      const [pergunta] = Object.keys(item);
      return pergunta;
    },
    getAgravoResposta(item) {
      const [resposta] = Object.values(item);
      return resposta.resposta;
    },
    buscaDados() {
      if (this.$route.query.interno) {
        this.isInterno = true;
      } else {
        this.isInterno = false;
      }
      this.$vs.loading();

      contractApi
        .getAutoProposalContract(this.$route.params.chave)
        .then((res) => {
          if (res.proposal.idTipoApolice == TIPO_APOLICE.RCVAT) {
            this.quotationData = { vehicles: res.rcvatVehicles };
          }

          this.dadosCotacao = res.auto;
          this.dadosProposta = calcularFranquia(res.proposal);

          let textoContrato = res.proposal.termos.find(
            (x) => x.tipoContrato == 'Termo de Ativação',
          );
          if (this.dadosProposta.tipoProposta == 'Reativação') {
            textoContrato = res.proposal.termos.find(
              (x) => x.tipoContrato == 'Termo de Reativação',
            );
          }
          this.textoContrato = textoContrato && textoContrato.modeloContrato;

          const documentType = this.isApolice()
            ? PDF_DOCUMENT_TYPES.POLICY
            : PDF_DOCUMENT_TYPES.PROPOSAL;
          this.customSectionsMsgs = getCustomSectionMsgs(
            res.proposal.termos,
            documentType,
          );
          this.insuranceCompanies = (res.congeners || []).map((congener) => ({
            id: congener.susep_code,
            label: congener.name,
          }));

          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          notify.notifyFail(
            this.$vs,
            'Ocorreu um erro, por favor tente novamente',
          );
        });
    },
    isApolice() {
      return this.dadosProposta.dataAdesao ? true : false;
    },
    isPessoaFisica(cpf) {
      return cpf.length <= 14 ? true : false;
    },
    getLabelSegurado(cpf, nomeSocial) {
      if (this.isPessoaFisica(cpf)) {
        return nomeSocial ? 'Nome Social' : 'Nome';
      }
      return 'Razão Social';
    },
    getVehicles() {
      return this.quotationData.vehicles || [];
    },
    getValorIof(valor, iof) {
      return valor * (iof / 100);
    },
    getValorPremioLiquido(valor, iof) {
      return valor - this.getValorIof(valor, iof);
    },
    showInstallments() {
      if (this.dadosProposta.nomePagamento !== 'Cartão de Crédito') {
        return true;
      }

      if (
        this.dadosProposta.purchaseStatus === PURCHASE_STATUS.AUTHORIZED ||
        this.dadosProposta.purchaseStatus === PURCHASE_STATUS.OVERPAID ||
        this.dadosProposta.purchaseStatus === PURCHASE_STATUS.PAID
      ) {
        return true;
      }

      return false;
    },
    getLabelVehicleTypeCode() {
      return (
        VEHICLE_TYPE_CODE_LABEL[this.dadosCotacao.vehicle.type_id] ||
        this.dadosCotacao.vehicle.type_id
      );
    },
    getVehicleIsSameLabel(is_same_vehicle) {
      return is_same_vehicle ? 'Sim' : 'Não';
    },
  },
  async created() {
    await this.buscaDados();
    this.$validator.localize('ptBr', locale);
  },
  components: { VxCard },
};
</script>

<style>
@import url('https://fonts.cdnfonts.com/css/gotham');

.cabecalho-impressao {
  display: none;
}

.wrapperPage {
  font-family: 'regular', 'Gotham', sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
}

.img-logo {
  width: 200px;
  height: 100px;
}

table {
  width: 100%;
  gap: 20px;
}

tr:nth-child(odd) {
  background-color: #edf4fb;
}

.title {
  background-color: #043562 !important;
  color: white;
}

.listItemsProtecoes {
  color: rgb(59, 59, 59);
  font-size: 0.9rem;
  font-weight: 600;
}

.textoRodape {
  font-family: 'Roboto', sans-serif;
  color: #3e3e3e;
  font-size: 0.75rem;
  font-weight: 400;
  text-align: justify;
  text-justify: inter-word;
}

.assinatura {
  border-top: 0.1rem solid #626262;
  margin: 0 1rem 0 1rem;
  padding-top: 0.5rem;
}

.A3 .sheet {
  width: 297mm;
  height: 419mm;
}
.A3.landscape .sheet {
  width: 420mm;
  height: 297mm;
}
.A4 .sheet {
  width: 210mm;
  height: 297mm;
}
.A4.landscape .sheet {
  width: 297mm;
  height: 210mm;
}
.A5 .sheet {
  width: 148mm;
  height: 210mm;
}
.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm;
}
.sheet.padding-15mm {
  padding: 15mm;
}
.sheet.padding-20mm {
  padding: 20mm;
}
.sheet.padding-25mm {
  padding: 25mm;
}
/** For screen preview **/
@media screen {
  body {
    background: #e0e0e0;
    display: flex;
    justify-content: center;
  }
  .sheet,
  .quebraPagina {
    background: white;
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
    margin-top: 1em;
    margin-bottom: 1em;
  }
}

@page {
  size: A4;
  margin: 1cm;
}

/* Defina o conteúdo do rodapé no formato "Página X de Y" no centro do rodapé */
@page {
  @bottom-center {
    content: 'Página ' counter(page) ' de ' counter(pages);
  }
}

/** Fix for Chrome issue #273306 **/
@media print {
  .A3.landscape {
    width: 420mm;
  }
  .A3,
  .A4.landscape {
    width: 297mm;
  }
  .A4,
  .A5.landscape {
    width: 210mm;
  }
  .A5 {
    width: 148mm;
  }
}

@media screen {
  .printer {
    display: none;
  }
}
@media print {
  .non-printer {
    display: none;
  }
  .vue-back-to-top {
    display: none !important;
  }
  .pdf {
    width: auto;
    height: 200mm;
  }
  .folha {
    height: 297mm;
    padding: 0 0 0 0;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
  #content-area {
    margin-left: 0;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0;
  }
  .vs-content-sidebar,
  .router-header,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
  .pagebreak-before {
    break-before: always;
    page-break-before: always;
  }
  .pagebreak-after {
    break-after: always;
    page-break-after: always;
  }
  .pagebreak-inside-avoid {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .vx-card__body {
    padding: 0.5rem !important;
    margin: 0 !important;
  }
  .img-logo {
    width: 100px;
    height: 50px;
  }
  .wrapperPage {
    padding-top: 1em !important;
  }
  .cabecalho-impressao {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .assinatura {
    border-top: 0.1rem solid #626262;
    margin: 0 1rem 0 1rem;
    padding-top: 0.5rem;
  }

  @page {
    size: A4;
    margin: 0;
  }
}
</style>
